import React, { useEffect } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const CorporateTravelersBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div className="container-fluid ctm-banner position-relative p-0" style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}>
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Corporate%20Travelers.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded &&
            <div className="ctm-text position-absolute text-white  mt-3 pt-xxl-4">
              <p className="fs4 text-uppercase busy grotesk-headings">CORPORATE TRAVEL</p>
              <HeadingH1 className="banner-headings w-75">Making Business Travel Easier</HeadingH1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  When work takes you places, we assure your journey is smooth and stress-free.
                  Blueberry Travel offers personalized corporate travel services that put your priorities first.
                </div>
              </div>
            </div>
          }
        </div>
      )}
    </BannerWrapper>
  );
};

export default CorporateTravelersBanner;
